// URL parsing for the Bid Manager. The legacy slug-encoded layout was
// removed; we now only read tab / sub from the URL on initial render and
// AppContext.currentProject is the source of truth for which project is
// open. `parseBidUrl` is the one helper still used (by BidProjectView).

export interface BidUrlSegments {
  slug?: string
  tab?: string
  sub?: string
}

export function parseBidUrl(): BidUrlSegments {
  if (typeof window === 'undefined') return {}
  const parts = window.location.pathname.split('/').filter(Boolean)
  if (parts[0] !== 'app' || parts[1] !== 'bidmanager') return {}
  return { slug: parts[2], tab: parts[3], sub: parts[4] }
}
